<template>
  <div v-if="sessionToken">
    <div v-if="role === 'super_Admin'">
      <control :username="username"
               :role="role"
               @apierror="setApiError"
               @apierrortext="setApiErrorText">
      </control>
    </div>
    <div v-if="role === 'admin'">
      <administrator :username="username"
                     @apierror="setApiError"
                     @apierrortext="setApiErrorText">
      </administrator>
    </div>
    <div v-else-if="role === 'basic'">
      <user :username="username"
            @apierror="setApiError"
            @apierrortext="setApiErrorText">
      </user>
    </div>
  </div>
  <div v-else>
    <login @apierror="setApiError"
           @apierrortext="setApiErrorText"
           @loginsuccess="loginSuccess"
           @username="setUsername">
    </login>
  </div>
</template>

<script>
import Control from '@/components/control/Control'
import Administrator from '@/components/administrator/Administrator'
import Login from '@/components/login/Login'
import User from '@/components/user/User'

export default {
  name: 'BodyComponent',
  props: ['username', 'role', 'sessionToken', 'error'],
  emits: ['loginsuccess', 'username', 'role', 'logout', 'apierror', 'apierrortext'],
  components: {
    Control,
    Administrator,
    Login,
    User,
  },
  methods: {
    setApiError: function (apiError) {
      this.$emit('apierror', apiError)
    },
    setApiErrorText: function (apiErrorText) {
      this.$emit('apierrortext', apiErrorText)
    },
    loginSuccess: function (event) {
      this.$emit('loginsuccess', event)
    },
    setUsername: function (newUsername) {
      this.$emit('username', newUsername)
    },
  },
}
</script>